export default function formatHoursToHHMM(hours) {
  const padHours = `${hours}`.padStart(2, "0");
  return `${padHours}:00`;
}
